{
  "Belastet": "Charge",
  "BelastetBerechtigt": "Charge et droit",
  "Berechtigt": "Droit",
  "dashboard.rechtehinweis.legalHintComment": " ",
  "dashboard.rechtehinweis.legalHintComment1": " ",
  "dashboard.rechtehinweis.legalHintHeader": "Remarque: validité des données",
  "dashboard.rechtehinweis.legalHintMessage": "L'exactitude et l'actualité des informations ne sont pas garanties. Les données du registre foncier sont déterminantes.",
  "L": "Charge",
  "LastRechtAbkürzung": "Charge et droit",
  "layouts.page.title": "Intercapi public",
  "LR": "Charge et droit",
  "R": "Droit",
  "rechteId": "Id de droit",
  "ZuGunsten": "en faveur de",
  "ZuGunstenLasten": "à la charge de et en faveur de",
  "ZuLasten": "à la charge de"
}
